import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { Pages } from "components/pages";
import StaffManagementSubPages from "components/pages/staff-management/sub-pages";


const StaffManagementEventRoute = ({ event, checkQr }) => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={ [ `${ path }/check-in-history`, `${ path }/check-in-history/page/:pageNum` ] } exact>
                <StaffManagementSubPages.CheckInHistory key={ event.id } event={ event } />
            </Route>
            <Route path={ `${ path }/workers/page/:pageNum` } exact>
                <StaffManagementSubPages.Workers key={ event.id } event={ event } />
            </Route>
            <Route path={ `${ path }/workers` } exact>
                <StaffManagementSubPages.Workers key={ event.id } event={ event } />
            </Route>
            <Route path={ `${ path }/attendance/page/:pageNum` } exact>
                <StaffManagementSubPages.Attendance event={ event } />
            </Route>
            <Route path={ `${ path }/attendance` } exact>
                <StaffManagementSubPages.Attendance event={ event } />
            </Route>
            <Route path={ `${ path }/audit-log/page/:pageNum` } exact>
                <StaffManagementSubPages.AuditLog event={ event } />
            </Route>
            <Route path={ `${ path }/audit-log` } exact>
                <StaffManagementSubPages.AuditLog event={ event } />
            </Route>
            <Route path={ path } exact>
                <StaffManagementSubPages.CheckInSetup event={ event } checkQr={ checkQr } />
            </Route>
            <Route path="*">
                <Pages.Page404 />
            </Route>
        </Switch>
    );
};

export default StaffManagementEventRoute;
